$(document).ready(function(){
  new Swiper('.coll_swiperMain', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Navigation arrows
    navigation: {
      nextEl: '.coll_next',
      prevEl: '.coll_prev',
    },
    slidesPerView: 1,
    breakpoints: {
      480:{
        slidesPerView: 2,
        spaceBetweenSlides: 30
      },
      767: {
        slidesPerView: 3,
        spaceBetweenSlides: 30
      },
      1024: {
        slidesPerView: 3,
        spaceBetweenSlides: 40
      },
       1199:{
        slidesPerView: 4,
        spaceBetweenSlides: 40
      }
    }
  });
});